export const exportCSV = (records, formatOutcome) => {
  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent +=
    "Observer,Facility,Unit,HCW Type,Moment,Outcome,Rings,Gloves,Nails,Bracelet,Created Date,Comments\r\n"; // Header row

  for (const record of records) {
    const row = [
      record.nurse,
      record.facility,
      record.unit,
      record.formQuestions.healthCareWorker,
      record.formQuestions.handHygieneMoment,
      formatOutcome(record.formQuestions.outcome, record.formQuestions.timer),
      record.formQuestions.custom.rings ? "Yes" : "No",
      record.formQuestions.custom.gloves ? "Yes" : "No",
      record.formQuestions.custom.nails ? "Yes" : "No",
      record.formQuestions.custom.bracelet ? "Yes" : "No",
      `"${new Date(record.createdAt).toLocaleString()}"`,
      `"${record.formQuestions.comment.replace(/"/g, '""')}"`,
    ].join(",");
    csvContent += row + "\r\n";
  }

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "hand_hygiene_records.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
